/**
 * This is the class to define a dropdown option to display in a dropdown menu
 * The options are now passed as an array of DropdownItem objects to the items prop of the HitDropdown component
 *
 * Explication of the different properties:
 * - label: the label to display for the option
 * - icon: icon displayed in front (prefix-icon) of the label
 * - iconSize: size used for the icon
 * - color: background color of the option -> useful to highlight a preselected option (number of column choice for example)
 * - separatorAfter: if true, a separator line will be displayed above the option
 * - clickEventHandler: a function to call when the option is clicked
 * - disabled: if true, the option is disabled and cannot be clicked
 * - tooltip: optional text shown on hover; a disabled item with a tooltip still notifies on click
 * - visible: if false, the option is not displayed in the dropdown menu
 */

export class DropdownItem {
  constructor({
    label = null,
    icon = null,
    iconSize = 'base',
    color = null,
    separatorAfter = false,
    clickEventHandler = null,
    disabled = false,
    tooltip = null,
    visible = true,
  } = {}) {
    this.label = label;
    this.icon = icon;
    this.iconSize = iconSize;
    this.color = color;
    this.disabled = disabled;
    this.tooltip = tooltip;
    this.separatorAfter = separatorAfter;
    this.clickEventHandler = clickEventHandler;
    this.visible = visible;
  }
}
